export default "__VITE_ASSET__BVDXiGeI__";